import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdsModule } from '../adcomponents/ad.module';

import { FormsModule } from '@angular/forms';
import { NgProgressModule } from 'ngx-progressbar';
import { NgxPaginationModule } from 'ngx-pagination';

import { ToolsRoutingModule } from './tools-routing.module';
import { ToolsComponent } from './tools.component';

//import { HotTableModule } from '@handsontable/angular';
//import {TooltipModule} from 'ng2-tooltip-directive';

@NgModule({
  imports: [
    CommonModule,
    ToolsRoutingModule,    
    FormsModule,
    AdsModule,
    NgProgressModule,
    NgxPaginationModule
  ],
  declarations: [
    ToolsComponent
  ],
  providers: []
})
export class ToolsModule {}
